module.exports = __webpack_public_path__ + "img/bg_row_1.67d30662.svg";